
import Ranking1 from "../../../assets/outline/Ranking1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Ranking1Icon({ className, dataTestid = "Ranking1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ranking1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
